import { ADD_MESSAGE, APPEND_TO_MESSAGE, RESET_AI_STATE, SET_MESSAGE_STATUS } from './actionTypes/ai';

export function addMessage(message) {
  return {
    type: ADD_MESSAGE,
    message
  };
}

export function appendToMessage(data) {
  return {
    type: APPEND_TO_MESSAGE,
    data
  };
}

export function setStatus(data) {
  return {
    type: SET_MESSAGE_STATUS,
    data
  };
}

export function resetAiData() {
  return { type: RESET_AI_STATE };
}
